import { Grid } from '@mui/material';
import { SlideParagraph, SlideTitle } from 'features/slides';
import SummaryPerformanceTable from 'pages/Cases/components/SummaryPerformanceTable';
import {
  columnsTrailingYearReturns,
  getPortfolioStatisticsRows,
  portfolioStatisticsChartFilter,
} from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type AnnualizedReturnsTableProps = {
  readonly filteredPerformance: any;
};

export function AnnualizedReturnsTable({
  filteredPerformance,
}: AnnualizedReturnsTableProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Annualized Returns</SlideTitle>
      </Grid>

      <Grid sx={{ width: '100%', backgroundColor: '#fff' }}>
        <SummaryPerformanceTable
          rows={getPortfolioStatisticsRows(
            portfolioStatisticsChartFilter({
              filteredPerformance,
              name: 'trailing_year_returns',
            }),
          )}
          columns={columnsTrailingYearReturns}
        />
      </Grid>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
